import type { ChartType } from '@/components/Chart/types/highcharts';

export const CHART_HEIGHT = 400;

export interface PreviewChartProps {
  type: ChartType;
  from?: string;
}
